var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('selectable-resource-types',_vm._b({model:{value:(_vm.resourceTypes),callback:function ($$v) {_vm.resourceTypes=$$v},expression:"resourceTypes"}},'selectable-resource-types',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }